import { render, staticRenderFns } from "./ClienteLavorazioni.vue?vue&type=template&id=31e51686"
import script from "./ClienteLavorazioni.vue?vue&type=script&lang=js"
export * from "./ClienteLavorazioni.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports